import React from 'react'

import '../styles/call-history'

function getIcon(method) {
    var className = 'glyphicon text-center '
    switch (method) {
        case 'INVITE': className += 'glyphicon glyphicon-transfer'; break
        case 'BYE': className += 'glyphicon glyphicon-ban-circle'; break
    }
    return <span className={className} />
}

function getMethod(method) {
    var text
    switch (method) {
        case 'INVITE': return <span>CallInvite</span>
        case 'BYE': return <span>CallEnd</span>
    }
}

export default ({ subscriber, calls, onRedial, profiles }) => (
    <div className="call-history">
        <h2>Call history</h2>
        {subscriber &&
            <div className="subscriber">
                <div>{subscriber.username}</div>
                <div>{subscriber.name}</div>
            </div>
        }
        {!(calls) &&
            <div className="loading">Loading data...</div>
        }
        <div className="calls">
            {calls.map((call, idx) => {
                const { source, destination, profile, message, start, end } = call
                const { time, src_user, dst_ouser } = start || end

                const local = new Date(time)
                const localTime = local.toLocaleTimeString('de-CH')
                const localDate = local.toLocaleDateString('de-CH')
                return (
                    <div key={idx} className="call">
                        <div className="time">{localTime}<br/>{localDate}</div>
                        <div className="details">
                            <div className="subscribers">
                                <div className="subscriber source">
                                    {source &&
                                        <span>{source.name} <small>({source.username})</small></span> ||
                                        <span>{src_user}</span>
                                    }
                                </div>
                                <div className="subscriber destination">
                                    {destination &&
                                        <span>{destination.name} <small>({destination.username})</small></span> ||
                                        <span>{dst_ouser}</span>
                                    }
                                </div>
                            </div>
                            <div>
                                {profile &&
                                    <div>
                                        {profile.name ? `${profile.name} (${profile.description})` : profile}
                                    </div>
                                }
                                {start &&
                                    <div>
                                        <span>{new Date(start.time).toLocaleString('de-CH')}</span>
                                        <span>{getIcon(start.method)} {getMethod(start.method)} <small>({start.sip_code} {start.sip_reason})</small></span>
                                        {start.request &&
                                            <span>by {start.request.initiator}</span>
                                        }
                                    </div>
                                }
                                {end &&
                                    <div>
                                        <span>{new Date(end.time).toLocaleString('de-CH')}</span>
                                        <span>{getIcon(end.method)} {getMethod(end.method)} <small>({end.sip_code} {end.sip_reason})</small></span>
                                        {end.request &&
                                            <span>by {end.request.terminator}</span>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        {onRedial && <div className="redial">
                            {src_user !== 'ctd' &&
                                <button className="btn" onClick={() => onRedial(src_user, dst_ouser, profile, message)}>redial</button>
                            }
                        </div>}
                    </div>
                )
            })}
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./components/CallHistory.jsx